import React from 'react';

const CHECK_INTERVAL_MS = 100;
const REQUIRED_CLEAR_STREAK = 2;

export function useAppSurfaceSettled(
  enabled: boolean,
  rootRef: React.RefObject<HTMLElement | null>,
) {
  const [isSettled, setIsSettled] = React.useState(false);

  React.useEffect(() => {
    if (!enabled || isSettled) {
      return;
    }

    let clearStreak = 0;
    const interval = setInterval(() => {
      const doc = rootRef.current?.ownerDocument ?? document;
      clearStreak = doc.querySelector('[data-app-loader]') ? 0 : clearStreak + 1;
      if (clearStreak >= REQUIRED_CLEAR_STREAK) {
        setIsSettled(true);
        clearInterval(interval);
      }
    }, CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [enabled, isSettled, rootRef]);

  return isSettled;
}
